import { createFileRoute } from '@tanstack/react-router';
import { FornecedorListagem } from '@/features/fornecedor/page/listagem/FornecedorListagem';

export const Route = createFileRoute('/a/fornecedor/')({
    component: FornecedorListagem,
});
